import React, {Component} from 'react';
import Button from '../inputs/button';
import Constants from '../../../../definitions/constants';
import InterfaceTooling from '../../../../tooling/interfaceTooling';

import Label from '../inputs/label';

class ToggleSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
  
  handleChangeOpenState = (event) => {
    this.setState({
      open: !this.state.open
    })
  };
  
  render() {
    const {
      className,
      title,
      comment,
      children
    } = this.props;
    return (
      <div className={"toogle-section" + 
          (this.state.open ? " toogle-section-content-opened" : "") + 
          (className ? " " + className : "")}>
        <Label
          className="toogle-section-title"
          onClick={this.handleChangeOpenState}
          label={title}
        />
        <i className={"arrow_expand fas fa-angle-" + (this.state.open ? "up" : "down")}></i>
        <div className="toogle-section-content">
          {(comment) ? (
            <label className="form_info toogle-section-comment">
              {comment}
            </label>
          ) : null}
          <div className="toogle-section-content-children">
            {children}
          </div>
        </div>
      </div>
    );
  };
}

export default ToggleSection;



// WEBPACK FOOTER //
// ./source/client/components/common/interface/toggleSection.jsx